import { LoginForm } from 'components/Blocks/LoginForm/LoginForm';
import { Popup } from 'components/Layout/Popup/Popup';
import { usePersistStore } from 'store/usePersistStore';

type LoginFormPopupProps = {
    email: string | null;
    shouldOverwriteCustomerUserCart?: boolean;
};

export const LoginFormPopup: FC<LoginFormPopupProps> = ({ email }) => {
    const { updateContactInformationState } = usePersistStore((s) => s);

    return (
        <Popup
            className="w-full !max-w-[500px] bg-white px-6 py-8 lg:px-16 lg:py-10"
            onCloseCallback={() => updateContactInformationState({ isLoginPopupOpen: false })}
        >
            <LoginForm
                defaultEmail={email ?? ''}
                onSuccessSubmit={() => updateContactInformationState({ isLoginPopupOpen: false })}
            />
        </Popup>
    );
};
